import { Image } from "@tiptap/extension-image";

export const CustomImage = Image.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      filename: {
        default: null,
        parseHTML: (el) => el.getAttribute("data-filename"),
        renderHTML: (attrs) => {
          return {
            ...(attrs.filename && { "data-filename": attrs.filename }),
          };
        },
      },
    };
  },
});
